import React, { useState } from "react";
import circle from '../../../assets/img/circulogris.png';
import lessCIrcle from '../../../assets/img/lessCIrcle.png';
import marketplaceAdd from '../../../assets/img/Marketplace-add.png';
import plusCircle from '../../../assets/img/plusCircle.png';
import Options from "../Options/Options";
import "../CardList/CardList.css";
import style from './CardListProducts.module.css'
import shoppingBagAdd from "../../../assets/img/Marketplace-add.png"
import Input from '../../../utils/components/Input/Input';
import { addToBag } from '../../../actions/marketPlaceActions'
import { changeQuantity } from '../../../actions/marketPlaceActions';
import { useDispatch } from 'react-redux';

const CardListProducts = ({
  zIndex = 0,
  addBag,
  maxQuantity = 0,
  productBag,
  product = [],
  pricePoints = '50',
  options = [],
  picture = '',
  text,
  onClick = () => { },
  onClickPicture = () => { }
}) => {

  const dispatch = useDispatch()

  const [quantity, setQuantity] = useState(productBag ? (productBag.quantity) : 1);
  const [isHover, setIsHover] = useState(false);

  const onClickPlusBtn = () => {
    if (maxQuantity > quantity) {

      setQuantity(parseInt(quantity) + 1);
    }
  }
  const onClickMinusBtn = () => {
    if (quantity >= 1) {
      setQuantity(parseInt(quantity) - 1);
    }
  }

  return (
    <div style={{ zIndex: `${zIndex}` }} className={`${style.content_card_list} grow-product-card`}
      onMouseLeave={() => setIsHover(false)}
      onMouseEnter={() => setIsHover(true)}
    >

      <div className={`${style.content_img_product}`} onClick={onClickPicture}>
        <img alt="img" className={`${style.img_product}`} onError={(e) =>
          e.target.src = circle} src={picture} onClick={onClickPicture}></img>
      </div>

      <div className={`${style.content_product_name}`} onClick={onClickPicture}>
        <div className={`${style.product_name}`}>
          {text}
        </div>
      </div>

      {
        isHover &&
        <div className={`${style.information_container}`}>
          <div className={`${style.price_text}`}>
            $ {product.price}
          </div>
          <div className={`${style.points_text}`}>
            {pricePoints} Ecos
          </div>
          <div className={`${style.quantity_container}`}>
            <span>

              <div className={`${style.btn_quantity_container}`}>

                <div className={`${style.quantity_product_warning}`}>{maxQuantity > 0 ? <>Stock {maxQuantity}</> : <>No hay stock</>}</div>

                {
                  maxQuantity > 0 && (<>
                    <div className={`${style.quantity_product_container}`}>

                      <img
                        className={`${style.quantity_icon}`}
                        onClick={() => {
                          onClickMinusBtn()
                        }}
                        src={lessCIrcle} alt=""
                      />
                      <input
                        type={"text"}

                        value={quantity}
                        // name={"quantityDeleted"}
                        onChange={e => {

                          if (Number.isInteger((parseInt(e.target.value, 10)))) {
                            if (e.target.value <= maxQuantity && e.target.value >= 0) {
                              setQuantity(e.target.value);
                            }

                          }
                          else if (e.target.value === '') {
                            setQuantity(e.target.value);
                          }
                        }}
                        className={`${style.quantity_product}`}
                      />
                      <img
                        className={`${style.quantity_icon}`}
                        onClick={() => {
                          onClickPlusBtn()
                        }} src={plusCircle} alt="" />

                    </div>

                    <div className={`${style.quantity_product_title}`}>Cantidad</div>
                  </>)
                }



              </div>
            </span>
            {
              maxQuantity > 0 && (
                <img
                  className={`${style.marketplace_add} animate__animated animate__bounceIn`}
                  onClick={() => {
                    if (maxQuantity > quantity) {
                      dispatch(addToBag(product));
                      dispatch(changeQuantity(product, (quantity)))
                    }

                  }} src={marketplaceAdd} alt="" />
              )
            }

          </div>
        </div>
      }

    </div>
  );
};



export default CardListProducts;
